module.exports = __webpack_public_path__ + "static/media/image2.9cdb8421.png";